<template>
    <div>
        <v-card-title>{{$t('buyWithProduct')}}</v-card-title>
        <v-divider></v-divider>
        <v-row>
            <v-col
                    sm="4"
                    md="4"
                    lg="4"
                    v-for="more in productsBuyWith"
                    :key="more.id"
            >
                <v-hover>
                    <template v-slot="{ hover }">
                        <v-card
                                class="d-flex"
                                outlined
                                :elevation="hover ? 3: 0"
                                link
                        >
                            <v-img :src="more.src" contain class="width-120"></v-img>
                            <div>
                                <v-card-title class="pl-0">{{more.productName}}</v-card-title>
                                <v-card-text class="pb-0 pl-0">
                                    <div>{{more.productCategory}}</div>
                                    <div>{{more.productLocation}}</div>
                                </v-card-text>
                                <v-card-actions class="pl-0">
                                    <v-rating
                                            :value="more.productRating"
                                            color="orange lighten-2"
                                            dense
                                            readonly
                                            small
                                            background-color="orange lighten-2"
                                    ></v-rating>
                                    <span class="orange--text text--lighten-2">({{more.reviewsAll}})</span>
                                </v-card-actions>
                            </div>
                        </v-card>
                    </template>
                </v-hover>
            </v-col>
        </v-row>
    </div>
</template>

<script>

    import './buy-with-product.scss'

    export default {
        name: "BuyWithProduct",
        props: ['buy-with'],
        data(){
            return {
                /*С этим товаром покупают*/
                productsBuyWith: [
                    {id:'1', productName:'Active', productCategory:'Удобрения', productLocation: 'г. Киев', productRating:3, reviewsAll:'58', src:'//cdn.agro-mp.local/images/products/product_image.png'},
                    {id:'2', productName:'Active', productCategory:'Удобрения', productLocation: 'г. Киев', productRating:3, reviewsAll:'58', src:'//cdn.agro-mp.local/images/products/product_image.png'},
                    {id:'3', productName:'Active', productCategory:'Удобрения', productLocation: 'г. Киев', productRating:3, reviewsAll:'58', src:'//cdn.agro-mp.local/images/products/product_image.png'},
                    {id:'4', productName:'Active', productCategory:'Удобрения', productLocation: 'г. Киев', productRating:3, reviewsAll:'58', src:'//cdn.agro-mp.local/images/products/product_image.png'},
                    {id:'5', productName:'Active', productCategory:'Удобрения', productLocation: 'г. Киев', productRating:3, reviewsAll:'58', src:'//cdn.agro-mp.local/images/products/product_image.png'},
                    {id:'6', productName:'Active', productCategory:'Удобрения', productLocation: 'г. Киев', productRating:3, reviewsAll:'58', src:'//cdn.agro-mp.local/images/products/product_image.png'},
                ],
            }
        },
    }
</script>

<style scoped>

</style>